import { number_round, UTILS__number } from '@shared/utils/utils_number';

export function FN_SERIALIZATION__data_serialize(data: any): any {
  let result: any;

  if (isNaN(data) && typeof data === 'number') {
    result = 'NaN';
  } else if (!data) {
    result = data;
  } else if (Array.isArray(data)) {
    result = data.map(item => FN_SERIALIZATION__data_serialize(item));
  } else if (data instanceof Map) {
    result = new Map();
    for (const [key, value] of data) {
      result.set(key, FN_SERIALIZATION__data_serialize(value));
    }
  } else if (data && typeof data === 'object') {
    if (typeof data.serialize === 'function') {
      result = data.serialize();
    } else {
      result = {};

      for (let key of Object.keys(data)) {
        result[key] = FN_SERIALIZATION__data_serialize(data[key]);
      }
    }
  } else if (UTILS__number.is_safe(data)) {
    result = number_round(data, 2);
  } else {
    result = data;
  }

  return result;
}
